import { http } from '../../services/http';
import type { Invoice, PlanChange } from '../billing/api';
import { newIdempotencyKey } from '../../utils/idempotency';

/** Platform console side of Phase 12: manual billing and sign-ups (ADR-053, ADR-054). */
export interface SignupRow {
  id: string;
  email: string;
  fullName: string;
  businessName: string;
  slug: string;
  status: 'pending' | 'completed' | 'expired' | 'superseded';
  createdAt: string;
  completedAt: string | null;
  tenantId: string | null;
}

export const PAYMENT_METHODS: Record<string, string> = {
  bank_transfer: 'Bank transfer',
  upi: 'UPI',
  card: 'Card',
  cash: 'Cash',
  cheque: 'Cheque',
  other: 'Other',
};

const once = () => ({ idempotencyKey: newIdempotencyKey() });

export const commercialApi = {
  invoices: (query: { status?: string; tenantId?: string }) => http.get<Invoice[]>('/platform/invoices', { query }),
  createInvoice: (
    tenantId: string,
    body: { periodStart: string; periodEnd: string; amount: string; dueDate?: string; notes?: string },
  ) => http.post<Invoice>(`/platform/tenants/${tenantId}/invoices`, body, once()),
  markPaid: (id: string, body: { method: string; reference?: string }) =>
    http.post<Invoice>(`/platform/invoices/${id}/mark-paid`, body, once()),
  voidInvoice: (id: string, reason: string) => http.post<Invoice>(`/platform/invoices/${id}/void`, { reason }),
  planChanges: (status?: string) =>
    http.get<PlanChange[]>('/platform/plan-change-requests', { query: status ? { status } : {} }),
  decide: (id: string, decision: 'approve' | 'reject', note?: string) =>
    http.post<PlanChange>(`/platform/plan-change-requests/${id}/${decision}`, note ? { note } : {}),
  signups: () => http.get<SignupRow[]>('/platform/signups'),
};

export const commercialKeys = {
  invoices: (query: object) => ['platform', 'invoices', query] as const,
  changes: ['platform', 'plan-changes'] as const,
  signups: ['platform', 'signups'] as const,
};
